import { useState } from 'react';
export const useFilters = (props) => {
    const [filters, setFilters] = useState(props?.defaultValues);
    const [delayedFilters, setDelayedFilters] = useState();
    const [searchQuery, setSearchQuery] = useState(props?.searchQuery);
    const [sortKey, setSortKey] = useState(props?.sortKey);
    const setFilter = (name, value) => setFilters(prevState => {
        return { ...prevState, [name]: value }; /** @todo fjern denne assertionen */
    });
    const setDelayedFilter = (name, value) => setDelayedFilters(prevState => {
        return { ...prevState, [name]: value }; /** @todo fjern denne assertionen */
    });
    const updateFilters = () => {
        setFilters(Object.assign({}, filters, delayedFilters));
    };
    const removeFilterFromState = (name, prevState) => {
        if (prevState) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [name]: _, ...rest } = prevState;
            return rest /** @todo fjern denne assertionen */;
        }
    };
    const activeFilters = filters &&
        Object.keys(filters)
            .filter(x => !!filters[x] &&
            filters[x] !== undefined &&
            filters[x] !== '' &&
            (typeof filters[x] !== 'object' || filters[x]?.value !== ''))
            .map(name => ({
            name,
            value: filters[name],
            handleRemove: async () => {
                setFilters(prevState => removeFilterFromState(name, prevState));
                setDelayedFilters(prevState => removeFilterFromState(name, prevState));
            },
        }));
    return {
        filters,
        setFilter,
        setDelayedFilter,
        activeFilters,
        searchQuery,
        setSearchQuery,
        sortKey,
        setSortKey,
        updateFilters,
    };
};
